/* eslint-disable */ 
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import App from './App.vue';
import BootstrapVue from 'bootstrap-vue';
import router from './router';
import Breadcrumbs from './components/bread_crumbs';
import { store } from './store';
import firebase from 'firebase/app';
import Vue2Filters from 'vue2-filters';
import VueSweetalert2 from 'vue-sweetalert2';
import VueFormWizard from 'vue-form-wizard';
import VueTour from 'vue-tour';
import Notifications from 'vue-notification';
import { Vue2Dragula } from 'vue2-dragula';
import Toasted from 'vue-toasted';
import SmartTable from 'vuejs-smart-table';
import * as VueGoogleMaps from 'vue2-google-maps';
import { VueMasonryPlugin } from 'vue-masonry';
import VueFeather from 'vue-feather';
import VueApexCharts from 'vue-apexcharts';
import FunctionalCalendar from 'vue-functional-calendar';
import vueKanban from 'vue-kanban';
import excel from 'vue-excel-export'

/* import the fontawesome  */
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {fas} from "@fortawesome/free-solid-svg-icons";
library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon)


import PxCard  from './components/Pxcard.vue';
Vue.component(PxCard.name, PxCard);

import { Icon } from 'leaflet';
delete Icon.Default.prototype._getIconUrl;

// Multi Language Add
import en from './locales/en.json';
import es from './locales/es.json';
import { defaultLocale, localeOptions,googleMapApiKey } from './constants/config';
import VueI18n from 'vue-i18n';

// Import Theme scss
import './assets/scss/app.scss';

// config for firebase
import config from './config.json';

import Axios from 'axios';
import Endpoints from '@/config/ApiEndpoints.js';
window.axios = Axios
window.Endpoints = Endpoints;
window.enableVehicleInspection = true;

import Config from '@/config/Config.js';

window.pbx_SiteTitle = Config.SiteTitle
var Company = JSON.parse(localStorage.getItem('Company'))
if(Company && Company.name){	
	window.pbx_SiteTitle = Company.name
}

Icon.Default.mergeOptions({
  iconRetinaUrl: require('./assets/images/vue2leaflet/marker-icon.png'),
  iconUrl: require('./assets/images/vue2leaflet/marker-icon.png')
});

Vue.use(VueFeather);
Vue.use(Vuelidate);

Vue.use(Toasted,{
  iconPack: 'fontawesome'
});
Vue.use(Vue2Dragula);

Vue.use(VueGoogleMaps, {
  load: {
    key: googleMapApiKey,
    libraries: 'places',
  },
});

Vue.use(Notifications);
Vue.use(Vue2Filters);
Vue.use(VueSweetalert2);
Vue.use(VueFormWizard);
Vue.use(VueTour);
Vue.use(BootstrapVue);
Vue.use(SmartTable);
Vue.use(require('vue-chartist'));
Vue.use(require('vue-moment'));
Vue.component('Breadcrumbs', Breadcrumbs);
Vue.use(VueMasonryPlugin);
Vue.component('apexchart', VueApexCharts);
Vue.use(FunctionalCalendar, {
  dayNames: ['M', 'T', 'W', 'T', 'F', 'S', 'S']
});
Vue.use(vueKanban);
Vue.use(VueI18n);
Vue.use(excel);



// setup fake backend
import { configureFakeBackend } from './_helpers';
configureFakeBackend();

const messages = { en: en, es: es };
const locale = (localStorage.getItem('currentLanguage') && localeOptions.filter(x => x.id === localStorage.getItem('currentLanguage')).length > 0) ? localStorage.getItem('currentLanguage') : defaultLocale;
const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: 'en',
  messages,
  silentTranslationWarn: true
});

Vue.config.productionTip = false;
firebase.initializeApp(config.firebase);

export const db = firebase.firestore();

Axios.interceptors.response.use(
  function(successRes) {  	    
    return successRes;
  }, 
  function(error) {
  	if(error.response && error.response.status && error.response.status == 401){
  		localStorage.removeItem('token');
  		localStorage.removeItem('tokenExpiry');
		localStorage.removeItem('User');
		localStorage.removeItem('userinfo');
		localStorage.removeItem('loggedIn');
		localStorage.removeItem('islogged');
		window.location = '/';
  	} 
    return error;
  }
);

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');